export default {
  es: {
    title1: "Contacta",
    title2: "con nosotros",
    formulario: {
      intro: {
        title: "¡Cuéntanos que necesitas!",
        description1:
          "Cualquier pregunta, duda o sugerencia que quieras hacernos llegar seas o no cliente de Iner, puedes hacerlo a través de este formulario de contacto.",
        description2:
          "Si lo prefieres también puedes llamarnos o dejarnos tu teléfono y te llamaremos nosotros lo antes posible.",
      },
      selector: {
        title: "El motivo de mi consulta es por:",
      },
      campos: {
        nombre: "Nombre y Apellidos*",
        telefono: "Teléfono*",
        email: "Email*",
        mensaje: "Mensaje",
      },
      checkboxes: {
        politica: "He leído y acepto la",
        politicaLink: "política de privacidad",
        comunicaciones:
          "Acepto recibir emails con información y promociones de Iner Energía",
        luz: "Luz",
        gas: "Gas",
        autoconsumo: "Autoconsumo",
        aerotermia: "Aerotermia",
        "coche-electrico": "Coche eléctrico",
        otro: "Otro",
      },
      boton: {
        enviar: "Enviar",
      },
      resultado: {
        titulo: "¡Nos pondremos en contacto contigo lo antes posible!",
        error: "Ha ocurrido un error al enviar el formulario",
      },
    },
    contacto: {
      telefono: "967 61 27 90",
      email: "iner@inerenergia.es",
    },
    help: {
      title:
        "¿Eres empresa o necesitas ayuda porque quieres instalar placas solares?",
      subtitle: "Si necesitas que te asesoremos aquí tienes la solución:",
      empresa: {
        title: "¿ERES EMPRESA?",
        description:
          "Te ayudamos a encontrar la tarifa <br> de luz que mejor te va.",
        button: "ESTUDIO PERSONALIZADO",
      },
      autoconsumo: {
        title: "¿Quieres instalar placas solares <br> y necesitas ayuda?",
        description: "SOMOS LA SOLUCIÓN",
        button: "TE AYUDAMOS",
      },
    },
  },
  en: {},
};



// WEBPACK FOOTER //
// ./src/translations/contacto.js